<template>
    <kgr-multi-select
        ref="dropdown"
        display="fullName"
        :label="label"
        :value="selection"
        :options="members"
        :loading="loading"
        searchable
        remove-selected
        @post-input="updateSelection($event)"
        @inputChanged="onInputChanged"
    />
</template>

<script>
import MemberRepository from '../../../../js/repository/MemberRepository.js';
import MultiSelect from './MultiSelect.vue';

export default {
    components: {
        'kgr-multi-select': MultiSelect,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        label: {
            type: String,
            required: false,
            default: null,
        },
        value: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            members: [],
            selection: [],
            loading: false,
            search: '',
        };
    },
    methods: {
        loadMembersByName() {
            this.loading = true;
            this.members = [];
            MemberRepository.findAll(this.clubId, null, null, '', this.search).then((members) => {
                this.members = members;
            }).catch(() => {
                this.$notify.error('error.loadingData');
            }).finally(() => this.loading = false);
        },
        onInputChanged(input) {
            this.search = input;
            setTimeout(this.loadMembersByName, 500);
        },
        updateSelection(value) {
            this.search = '';
            if (value.length === 0) {
                this.selection = [];
                this.$emit('input', []);
                this.$nextTick(() => {
                    this.$emit('post-input', value);
                });
            } else if (value.length > 0) {
                this.selection = value;
                this.$emit('input', value);
                this.$nextTick(() => {
                    this.$emit('post-input', value);
                });
            }
        },
    },
};
</script>
